import React from "react";
import AddRemitocForm from "./AddRemitocForm";
import "../css/admin.css";

const AddRemitoc = ({ show, setShow }) => {
  const handleToggle = () => setShow((s) => !s);

  return (
    <>
      <div>
        <button className="btn btn-dark" onClick={handleToggle}>
          {show ? "Ocultar Form" : "Agregar Remito"}
        </button>
        <hr />
      </div>

      {/* 👇 SIEMPRE montado; el modal se abre/cierra con show */}
      <AddRemitocForm
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default AddRemitoc;
